import { defineMessages } from "react-intl";

export const sidebarMessages = defineMessages({
  collapse: {
    id: "eOJ4QU",
    defaultMessage: "Collapse sidebar",
  },
  expand: {
    id: "1JgBls",
    defaultMessage: "Expand sidebar",
  },
});
